import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ActivityService } from '../shared-activities/activity.service';
import { SharedCalendarEvent, AttendeeWithInitials } from '../../model/calendar.model';
import { ProfileService } from 'src/app/profile/profileService';
import { MenuItem, MessageService } from 'primeng/api';
import { VendorConfigService } from '../config-external-client/services/vendor-config.service';
import { VendorConstant } from '../../constants/vendor.constant';
import { IDateFilterModel } from 'src/app/reports/models/reports-filter.models';
import { Account } from 'src/app/accounts-v2/models/account.model';
import { sort } from '../../helpers';
import { TimeZoneService } from '../../services/timezone.service';

@Component({
  selector: 'app-shared-calendar',
  templateUrl: './shared-calendar.component.html',
  styleUrl: './shared-calendar.component.scss'
})
export class SharedCalendarComponent implements OnInit, OnChanges {
  @Input() objectId: any;
  @Input() isSidebar;
  @Input() objectTypeId: number;
  @Input() channelId: number;
  @Input() eventFromModule: boolean;

  displayAddEventModal: boolean = false;
  isViewMode = false;
  selectedObject: any = null;
  @Input() selectedAccount: Account;
  eventMode : string = "";
  attendees: AttendeeWithInitials[] = [];
  events: any[] = [];
  filteredEvents: SharedCalendarEvent[] = [];
  selectedDateFilter: string;
  cols: any[];
  isLoading: boolean = false;
  error: string | null = null;
  selectedFilter: string = 'all'; // Default filter value

  filterOptions = [
    { label: "Today's Events", value: 'today' },
    { label: 'All Events', value: 'all' }
  ];
  avatarColors: string[] = [
    '#2196F3', '#4CAF50', '#FF9800', '#E91E63',
    '#9C27B0', '#673AB7', '#3F51B5', '#00BCD4'
  ];

    dataIsOperatorList: string[] = [
        "All Events","Today", "Yesterday", "This Month", "Last Month", "Last 7 Days", "Last 15 Days", "Last 30 Days", "Last 60 Days", "Last 90 Days", "Custom"
    ];
  dateFrom: Date = null;
  dateTo: Date = null;

  initialCalerdarListCount: number;
  usersInCalendar: any;
  contextMenuItems: MenuItem[];
  selectedEvent:any;

  constructor(private activityService: ActivityService,
    private profileService: ProfileService,
    private messageService: MessageService,
    private vendorConfigService: VendorConfigService,
    private timeZoneService: TimeZoneService
  ) {
    this.cols = [
      { field: 'calendarEvent.name', header: 'Name', sort: true },
      { field: 'calendarEvent.startDate', header: 'Start Date',sort: true },
      { field: 'calendarEvent.endDate', header: 'End Date', sort: true },
      { field: 'calendarEvent.description', header: 'Description', sort: true },
      { field: 'attendees', header: 'Attendees', sort: false },
      { field: 'calendarEvent.createdBy', header: 'Created By', sort: true },
      { field: 'calendarEvent.createdDate', header: 'Created Date', sort: true },
      ]
    }

  ngOnInit() {
    this.fetchEvents();
    this.getVendorConfig();
    this.selectedDateFilter = this.dataIsOperatorList[0];
  }



  ngOnChanges(changes: SimpleChanges) {
    if (changes?.eventFromModule?.currentValue) {
      this.eventFromModule = changes.eventFromModule.currentValue;
  }
}


  buildContextMenu(){
    this.contextMenuItems= [];
    this.contextMenuItems.push(
    //   {
    //     label: 'View',
    //     icon: 'pi pi-folder-open',
    //     command: () => this.editEvent(this.selectedEvent)
    //   },
      {
        label: 'Edit',
        icon: 'pi pi-pencil',
        command: () => this.editEvent(this.selectedEvent)
      },
    //   {
    //     label: 'Delete',
    //     icon: 'pi pi-trash',
    //     // command: () => this.deleteWorkbook(this.selectedTable),
    //   },
    );
  }

  getInitials(name: string): string {
    if (!name || name.trim().length === 0) {
      return 'U';
    }

    const names = name.trim().split(/\s+/); // Split by spaces and handle extra spaces
    if (names.length === 1) {
      return names[0][0].toUpperCase();
    } else if (names.length === 2) {
      return (names[0][0] + names[1][0]).toUpperCase();
    } else {
      return (names[0][0] + names[1][0]).toUpperCase(); // First and second initials for 3+ names
    }
  }

  getRemainingAttendeesTooltip(attendees: AttendeeWithInitials[]): string {
    if (attendees.length <= 2) return '';
    return attendees.slice(2).map(a => a.name).join('\n');
  }

  processAttendees(attendeesString: string): AttendeeWithInitials[] {
    if (!attendeesString || attendeesString === 'N/A') return [];

    return attendeesString.split(', ').map((name, index) => ({
      name,
      initials: this.getInitials(name),
      color: this.avatarColors[index % this.avatarColors.length]
    }));
  }

  async fetchEvents() {
    try {
      this.isLoading = true;
      this.error = null;
      const response = await this.activityService.getAllObjectEvents(this.selectedAccount?.id, this.objectTypeId)||[];
      this.events = (response as any[]).map(event => ({
        ...event,
        attendees: event.calendarEvent?.calendarEventAttendees?.map(a => a.name).join(', ') || 'N/A'
      }));
      // this.events = response as any[];
      this.filterEvents();
    } catch (err) {
      this.error = 'Failed to fetch calendar events';
    } finally {
      this.isLoading = false;
    }
  }

  openCreateEventModal(){
    this.eventMode = 'add';
    this.selectedEvent = null;
    this.displayAddEventModal = true;
  }

  cancelEvent() {
    this.eventMode = "";
    this.displayAddEventModal = false;
  }

  getCalendarList(oAuthRegistrationId: number): void {
    //this.appMainService.isShowSpinner('getCalendarList');
    this.profileService.getRegisteredCalenderConfig(oAuthRegistrationId).subscribe(
        {
            next: (response) => {
                const res = response;
                this.initialCalerdarListCount = res?.length;
                this.usersInCalendar = this.prepareDataForMenuItems(res) || [];
                //this.appMainService.isHideSpinner('getCalendarList');
            },
            error: (error) => {
                //this.appMainService.isHideSpinner('getCalendarList');
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: error?.error?.message ? error?.error?.Message : 'Calendar list are not loaded, please try again...'
                });
            },
            complete: () => {

            },
        });
  }

  prepareDataForMenuItems(originalData): any[]{
    const modifiedData: any[] = originalData.map((obj) => ({
        label: obj?.userMailId,
        id: obj?.id,
        items: [
          {
            label: 'Calendar',
            id: obj?.id
          }
        ]
    }));
    return modifiedData;
  }

  getVendorConfig(): void {
    //this.appMainService.isShowSpinner('getVendorConfig');
    this.vendorConfigService.getVendorConfig(VendorConstant.CalendarCategoryId).subscribe(
        {
            next: (response) => {
                const configList = response || [];
                const calendarConfig = configList.find((x) => x.name === 'OutlookCalender');
                this.getCalendarList(calendarConfig?.vendorOAuthRegistration?.id);
                //this.appMainService.isHideSpinner('getVendorConfig');
            },
            error: (error) => {
                //this.appMainService.isHideSpinner('getVendorConfig');
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: error?.error?.message ? error?.error?.Message : 'Configuration are not loaded, please try again...'
                });
            },
            complete: () => {

            },
        });
  }

  //#region Edit Event

  editEvent(event: any) {
    this.eventMode = 'edit';
    this.displayAddEventModal = true;
    this.isViewMode = false;

    // Format the event data to match your form's expected structure

  }
  //#endregion Edit Event

  // #region Filter Events
  onFilterChange(event: any) {
    if (!event?.value) return;

    this.selectedDateFilter = event.value;
    if (this.selectedDateFilter !== 'Custom') {
      this.dateFrom = null;
      this.dateTo = null;
    }
    this.filterEvents();
  }

  onCustomDateChange() {
    if (this.selectedDateFilter === 'Custom' && this.dateFrom && this.dateTo) {
      this.filterEvents();
    }
  }

  resetFilter(event): void {
    this.selectedDateFilter = null;
    this.dateFrom = null;
    this.dateTo = null;
    this.selectedDateFilter = this.dataIsOperatorList[0];
    this.filterEvents();
  }

  filterEvents() {
    if (!this.events || !this.selectedDateFilter) {
      this.filteredEvents = [];
      return;
    }

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    // If 'all' is selected, show all events
    if (this.selectedDateFilter === 'All Events' || (this.selectedDateFilter === 'Custom' && (!this.dateFrom || !this.dateTo))) {
      this.filteredEvents = [...this.events];
      return;
    }

    const dateRange = this.dateOnOperatorListValue();
    const startRange = new Date(dateRange.dateRangeFrom).getTime();
    const endRange = new Date(dateRange.dateRangeTo).getTime();

    this.filteredEvents = this.events.filter(item => {
        const formattedDate = item.calendarEvent?.startDate.endsWith('Z') ? item.calendarEvent?.startDate : item.calendarEvent?.startDate + 'Z';
        const itemDate = new Date(formattedDate).getTime();
        return itemDate >= startRange && itemDate <= endRange;
    })
  }

  dateOnOperatorListValue() {

      let today = new Date(); //Date with time offset 0
      let todayCopy = new Date();
      let dateRangeFrom: Date | null = null;
      let dateRangeTo: Date | null = null;

      switch (this.selectedDateFilter) {
        case 'Today': {
          dateRangeFrom = today;
          dateRangeTo = today;
          break;
        }
        case 'Yesterday': {
          const yesterday = new Date(todayCopy);
          yesterday.setDate(todayCopy.getDate() - 1);
          dateRangeFrom = yesterday;
          dateRangeTo = yesterday;
          break;
        }
        case 'This Month': {
          const firstday = new Date(todayCopy);
          firstday.setDate(1);
          dateRangeFrom = firstday;
          dateRangeTo = new Date(today.getFullYear(), today.getMonth() + 1, 0);
          break;
        }
        case 'Last Month': {
          dateRangeFrom = new Date(today.getFullYear(), today.getMonth() - 1, 1);
          dateRangeTo = new Date(today.getFullYear(), today.getMonth(), 0);
          break;
        }
        case 'Last 7 Days': {
          const seven = new Date(todayCopy);
          seven.setDate(todayCopy.getDate() - 7);
          dateRangeFrom = seven;
          dateRangeTo = today;
          break;
        }
        case 'Last 15 Days': {
          const fifteen = new Date(todayCopy);
          fifteen.setDate(todayCopy.getDate() - 15);
          dateRangeFrom = fifteen;
          dateRangeTo = today;
          break;
        }
        case 'Last 30 Days': {
          const thirty = new Date(todayCopy);
          thirty.setDate(todayCopy.getDate() - 30);
          dateRangeFrom = thirty;
          dateRangeTo = today;
          break;
        }
        case 'Last 60 Days': {
          const sixty = new Date(todayCopy);
          sixty.setDate(todayCopy.getDate() - 60);
          dateRangeFrom = sixty;
          dateRangeTo = today;
          break;
        }
        case 'Last 90 Days': {
          const ninety = new Date(todayCopy);
          ninety.setDate(todayCopy.getDate() - 90);
          dateRangeFrom = ninety;
          dateRangeTo = today;
          break;
        }
        case 'Custom': {
            dateRangeFrom = this.dateFrom;
            dateRangeTo = this.dateTo;
            break;
        }
        default: {
          dateRangeFrom = null;
          dateRangeTo = null;
          break;
        }
      }

      if ((dateRangeFrom && dateRangeTo)) {
        dateRangeFrom = this.timeZoneService._getUTCDateTimeWithZone(dateRangeFrom, true, true, !['This Month', 'Last Month'].includes(this.selectedDateFilter));
        dateRangeTo = this.timeZoneService._getUTCDateTimeWithZone(dateRangeTo, true, true, !['This Month', 'Last Month'].includes(this.selectedDateFilter));
        dateRangeTo.setDate(dateRangeTo.getDate() + 1);
        dateRangeTo = new Date(dateRangeTo.getTime() - 1000);
        // item.values.push(this.timeZoneService._getUTCDateTimeString(dateRangeFrom), this.timeZoneService._getUTCDateTimeString(dateRangeTo));
      }

      return {dateRangeFrom: this.timeZoneService._getUTCDateTimeString(dateRangeFrom), dateRangeTo: this.timeZoneService._getUTCDateTimeString(dateRangeTo)};
    }

  private isSameDay(date1: Date, date2: Date): boolean {
    return date1.getFullYear() === date2.getFullYear() &&
          date1.getMonth() === date2.getMonth() &&
          date1.getDate() === date2.getDate();
  }
   // #endregion Filter Events
}
